import { render, staticRenderFns } from "./OrgMapping.vue?vue&type=template&id=6474c85a&scoped=true"
import script from "./OrgMapping.vue?vue&type=script&lang=js"
export * from "./OrgMapping.vue?vue&type=script&lang=js"
import style0 from "./OrgMapping.vue?vue&type=style&index=0&id=6474c85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474c85a",
  null
  
)

export default component.exports